// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".newsDetails-head-autocomplete /deep/ .el-scrollbar__view li{position:relative;padding:0 20px 0 20px}.newsDetails-head-autocomplete /deep/ .el-scrollbar__view li .name{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.newsDetails-head-autocomplete /deep/ .el-scrollbar__view li .addr{position:absolute;top:0;right:20px;font-size:12px;color:#f59a23}", ""]);
// Exports
module.exports = exports;
